export const UIBUILDER_PAGES = 'UIB_PAGES';
export const UIBUILDER_THEME = 'UIB_THEME';
export const UIBUILDER_MENU = 'UIBUILDER_MENU';
export const UIBUILDER_DESIGN_ELEMENTS = 'UIB_DESIGN_ELEMENTS';
export const UIBUILDER_BOTTOM_NAV = 'UIB_BOTTOM_NAV';
export const UIBUILDER_DIGITAL_KEY = 'UIB_DIGITAL_KEY';

export const UIBUILDER_PAGE_VIEW = 'uib_page_view';
export const UIBUILDER_PAGE_BUILDER = 'uib_page_builder';
export const UIBUILDER_PAGE_CREATE = 'uib_page_create';
export const UIBUILDER_PAGE_EDIT = 'uib_page_edit';

export const HERO_BANNER_W_CTA = 'HERO_BANNER_W_CTA';
export const HERO_BANNER_W_SUBTITLE_CTA = 'HERO_BANNER_W_SUBTITLE_CTA';
export const HERO_BANNER_W_TITLE = 'HERO_BANNER_W_TITLE';
export const SMALL_BANNER_W_TITLE = 'SMALL_BANNER_W_TITLE';
export const CAROUSEL_PORTRAIT_W_BG = 'CAROUSEL_PORTRAIT_W_BG';
export const CAROUSEL_LANDSCAPE_W_BG = 'CAROUSEL_LANDSCAPE_W_BG';
export const CAROUSEL_WO_BG = 'CAROUSEL_WO_BG';
export const CAROUSEL_LARGE_IMG_W_BG = 'CAROUSEL_LARGE_IMG_W_BG';
export const CAROUSEL_W_DESCRIPTION = 'CAROUSEL_W_DESCRIPTION';
export const IMAGE_W_TITLE_BODY = 'IMAGE_W_TITLE_BODY';
export const IMAGE_LARGE_W_TITLE_BODY = 'IMAGE_LARGE_W_TITLE_BODY';
export const IMAGE_LARGE_W_BG = 'IMAGE_LARGE_W_BG';
export const IMAGE_LARGE = 'IMAGE_LARGE';
export const IMAGE_LARGE_W_TITLE_SUBTITLE_BODY = 'IMAGE_LARGE_W_TITLE_SUBTITLE_BODY';
export const CAROUSEL_SOCIAL = 'CAROUSEL_SOCIAL';
export const ACCORDION_W_ICON = 'ACCORDION_W_ICON';
export const ACCORDION_WO_ICON = 'ACCORDION_WO_ICON';
export const BUTTON_W_CTA = 'BUTTON_W_CTA';
export const BUTTON_W_ICON = 'BUTTON_W_ICON';
export const SOCIAL_COMPONENT = 'SOCIAL_COMPONENT';
export const LIST_COMPONENT = 'LIST_COMPONENT';
export const DETAIL_PAGE = 'DETAIL_PAGE';
export const SERVICE_DETAIL_COMPONENT = 'SERVICE_DETAIL_COMPONENT';

// export const CAROUSEL_LARGE_IMG_W_BG = "CAROUSEL_LARGE_IMG_W_BG";
export const CAROUSEL_LANDSCAPE_W_BODY_CTA = 'CAROUSEL_LANDSCAPE_W_BODY_CTA';
export const BASIC_TEXT_COMPONENT = 'BASIC_TEXT_COMPONENT';

export const libraryComponents = [
  {
    header: 'Basic Components',
    id: 'basicComponent',
    imageActive: '/assets/img/ui-builder/basic-component-active.svg',
    imageInactive: '/assets/img/ui-builder/basic-component-inactive.svg',
    components: [
      {
        id: 'BASIC_TEXT_COMPONENT',
        title: 'Text',
        image: '/assets/img/ui-builder/text.svg',
        componentTitle: 'Text',
      },
    ],
  },
  {
    header: 'Banners',
    id: 'banners',
    imageActive: '/assets/img/ui-builder/banners-active.svg',
    imageInactive: '/assets/img/ui-builder/banners-inactive.svg',
    components: [
      {
        id: 'HERO_BANNER_W_CTA',
        title: '1B - Hero Banner, H1, CTA',
        image: '/assets/img/ui-builder/banner-with-cta.png',
        componentTitle: '1B - Hero Banner, H1, CTA',
      },
      {
        id: 'HERO_BANNER_W_SUBTITLE_CTA',
        title: '1A - Hero Banner, H1, H3, CTA',
        image: '/assets/img/ui-builder/title-cta.png',
        componentTitle: '1A - Hero Banner, H1, H3, CTA',
      },
      {
        id: 'HERO_BANNER_W_TITLE',
        title: '1C - Hero Banner, H2',
        image: '/assets/img/ui-builder/banner-title.png',
        componentTitle: '1C - Hero Banner, H2',
      },
      {
        id: 'SMALL_BANNER_W_TITLE',
        title: '1D - Small Hero, H2, CTA',
        image: '/assets/img/ui-builder/banner-with-title.png',
        componentTitle: '1D - Small Hero, H2, CTA',
      },
    ],
  },
  {
    header: 'Carousels',
    id: 'carousals',
    imageActive: '/assets/img/ui-builder/carousal-active.svg',
    imageInactive: '/assets/img/ui-builder/carousal-inactive.svg',
    components: [
      {
        id: 'CAROUSEL_PORTRAIT_W_BG',
        title: '2A - Portrait Carousel',
        image: '/assets/img/ui-builder/portrait-bg.png',
        componentTitle: '2A - Portrait Carousel',
      },
      {
        id: 'CAROUSEL_LANDSCAPE_W_BG',
        title: '2B - Landscape Carousel',
        image: '/assets/img/ui-builder/landscape-bg.png',
        componentTitle: '2B - Landscape Carousel',
      },
      {
        id: 'CAROUSEL_WO_BG',
        title: '2C - Carousel - No BKGD',
        image: '/assets/img/ui-builder/caro-wo-bg.png',
        componentTitle: '2C - Carousel - No BKGD',
      },
      {
        id: 'CAROUSEL_LARGE_IMG_W_BG',
        title: '6 - Large IMG w/Carousel',
        image: '/assets/img/ui-builder/large-img-caro.png',
        componentTitle: '6 - Large IMG w/Carousel',
      },
      {
        id: 'CAROUSEL_LANDSCAPE_W_BODY_CTA',
        title: '2D - Landscape C, Body, CTA',
        image: '/assets/img/ui-builder/landscape-body-w-cta.png',
        componentTitle: '2D - Landscape C, Body, CTA',
      },
      {
        id: 'CAROUSEL_SOCIAL',
        title: '2E - Social Component',
        image: '/assets/img/ui-builder/landscape-social.png',
        componentTitle: '2E - Social Component',
      },
      {
        id: 'CAROUSEL_W_DESCRIPTION',
        title: '2F - Carousel w Description',
        image: '/assets/img/ui-builder/landscape-desc-bg.png',
        componentTitle: '2F - Carousel w Description',
      },
    ],
  },
  {
    header: 'Image Components',
    id: 'image-components',
    imageActive: '/assets/img/ui-builder/image-component-active.svg',
    imageInactive: '/assets/img/ui-builder/image-component-inactive.svg',
    components: [
      {
        id: 'IMAGE_W_TITLE_BODY',
        title: '3 - DBL IMG w/Title, Body',
        image: '/assets/img/ui-builder/title-body.png',
        componentTitle: '3 - DBL IMG w/Title, Body',
      },
      {
        id: 'IMAGE_LARGE_W_TITLE_BODY',
        title: '4 - Large Image w/Body, CTA',
        image: '/assets/img/ui-builder/large-img-body.png',
        componentTitle: '4 - Large Image w/Body, CTA',
      },
      {
        id: 'IMAGE_LARGE_W_BG',
        title: '5 - LRG IMG w/BKGD',
        image: '/assets/img/ui-builder/title-bg.png',
        componentTitle: '5 - LRG IMG w/BKGD',
      },
      {
        id: 'IMAGE_LARGE',
        title: '15 - Large Image',
        image: '/assets/img/ui-builder/large-img.png',
        componentTitle: '15 - Large Image',
      },
      {
        id: 'IMAGE_LARGE_W_TITLE_SUBTITLE_BODY',
        title: '10 - Large Image w/Body, CTA, H3',
        image: '/assets/img/ui-builder/large-img-body.png',
        componentTitle: '10 - Large Image w/Body, CTA, H3',
      },
      {
        id: 'SERVICE_DETAIL_COMPONENT',
        title: '8 - Product/Service Detail',
        image: '/assets/img/ui-builder/detail-page.png',
        componentTitle: '8 - Product/Service Detail',
      },
    ],
  },
  {
    header: 'Accordions',
    id: 'accordions',
    imageActive: '/assets/img/ui-builder/accordions-active.svg',
    imageInactive: '/assets/img/ui-builder/accordions-inactive.svg',
    components: [
      {
        id: 'ACCORDION_W_ICON',
        title: '9A - Accordion w/Icon',
        image: '/assets/img/ui-builder/accordion-with-icon.png',
        componentTitle: '9A - Accordion w/Icon',
      },
      {
        id: 'ACCORDION_WO_ICON',
        title: '9B - Accordion w/o Icon',
        image: '/assets/img/ui-builder/accordion-without-icon.png',
        componentTitle: '9B - Accordion w/o Icon',
      },
    ],
  },
  {
    header: 'Buttons',
    id: 'buttons',
    imageActive: '/assets/img/ui-builder/buttons-active.svg',
    imageInactive: '/assets/img/ui-builder/buttons-inactive.svg',
    components: [
      {
        id: 'BUTTON_W_CTA',
        title: '16 - CTA Button',
        image: '/assets/img/ui-builder/cta-button-1.png',
        componentTitle: '16 - CTA Button',
      },
      {
        id: 'BUTTON_W_ICON',
        title: 'Button with Icon',
        image: '/assets/img/ui-builder/button-with-icon.png',
        componentTitle: 'Button with Icon(s)',
      },
    ],
  },
  {
    header: 'Elevate Components',
    id: 'elevate-component',
    imageActive: '/assets/img/ui-builder/elevate-components-active.svg',
    imageInactive: '/assets/img/ui-builder/elevate-components-inactive.svg',
    components: [
      {
        id: 'LIST_COMPONENT',
        title: '7 - List Component',
        image: '/assets/img/ui-builder/list-component.png',
        componentTitle: '7 - List Component',
      },
      {
        id: 'DETAIL_PAGE',
        title: 'Detail Page',
        image: '/assets/img/ui-builder/detail-page.png',
        componentTitle: 'Detail Page',
      },
    ],
  },
];

export const REDIRECT_TYPE_IN_APP_PAGE = 'IN_APP';
export const REDIRECT_TYPE_EXTERNAL = 'EXTERNAL';
export const REDIRECT_TYPE_FLOW = 'FLOW';

export const REDIRECT_STATUS_ACTIVE = 'redirect_status_active';
export const REDIRECT_STATUS_INACTIVE = 'redirect_status_inactive';

export const CTA_STATUS_ACTIVE = 'cta_status_active';
export const CTA_STATUS_INACTIVE = 'cta_status_inactive';

export const PHONE_STATUS_ACTIVE = 'phone_status_active';
export const PHONE_STATUS_INACTIVE = 'phone_status_inactive';

export const EMAIL_STATUS_ACTIVE = 'email_status_active';
export const EMAIL_STATUS_INACTIVE = 'email_status_inactive';

export const VIEW_ALL_STATUS_ACTIVE = 'view_all_status_active';
export const VIEW_ALL_STATUS_INACTIVE = 'view_all_status_inactive';

export const UIBUILDER_MENU_DISCOVER = 'Discover';
export const UIBUILDER_MENU_HAMBURGER = 'Hamburger Menu';

export const ICONS_STATUS_ACTIVE = 'icons_status_active';
export const ICONS_STATUS_INACTIVE = 'icons_status_inactive';

export const FLOW_MAPPING = {
  RESTAURANT_BOOKING: 'RESTAURANT',
  WELLNESS_BOOKING: 'WELLNESS',
};

export const PRE_CHECKIN_UI_BUILDER_MOBILE_MENU = 'PRE_CHECKIN_UI_BUILDER_MOBILE_MENU';
export const POST_CHECKIN_UI_BUILDER_MOBILE_MENU = 'POST_CHECKIN_UI_BUILDER_MOBILE_MENU';
